__turbopack_context__.v({
  "image": "SmallLogo-module-scss-module__1qCQBa__image",
});
